/**
 * View Accordion block.
 * @module components/ItaliaTheme/Blocks/Accordion/View
 * Customization
 * Added title field
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ViewBlock from 'design-comuni-plone-theme/components/ItaliaTheme/Blocks/Accordion/Block/ViewBlock';
import { Container, Card, CardBody } from 'design-react-kit';

/**
 * View Accordion block class.
 * @class View
 * @extends Component
 */
const AccordionView = ({ data, block }) => {
  const [itemOpen, setItemOpen] = useState(-1);
  const toggle = (index) => {
    setItemOpen(index === itemOpen ? -1 : index);
  };
  const id = new Date().getTime();
  return (
    <div className="block accordion">
      <div className="public-ui">
        <div className="full-width section section-muted section-inset-shadow py-5">
          <Container className="px-lg-4">
            <h2 className="text-primary mb-5 mt-4">{data.title}</h2>
            <Card className="card-bg rounded" noWrapper={false} space tag="div">
              <CardBody tag="div">
                {data.subblocks.map((subblock, index) => (
                  <ViewBlock
                    data={subblock}
                    toggle={() => {
                      return () => toggle(index);
                    }}
                    isOpen={itemOpen === index}
                    key={index}
                    id={id}
                    index={index}
                  />
                ))}
              </CardBody>
            </Card>
          </Container>
        </div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
AccordionView.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AccordionView;
